import { combineReducers, configureStore } from '@reduxjs/toolkit';
import accountsReducer from './reducers/accountsSlice';
import cardsReducer from './reducers/cardsSlice';
import appReducer from './reducers/appSlice';
import userReducer from './reducers/userSlice';
import countriesReducer from './reducers/countriesSlice';
import currenciesReducer from './reducers/currenciesSlice';
import { api } from 'shared/api';
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { setupListeners } from '@reduxjs/toolkit/query';
import { persistorManager } from 'shared/libs/utils/PersistorManager/PersistorManager';
import storage from 'redux-persist/lib/storage';

const userPersistConfig = {
  key: 'user',
  storage: storage,
};

const accountsPersistConfig = {
  key: 'accounts',
  storage: storage,
};

const cardsPersistConfig = {
  key: 'cards',
  storage: storage,
};

const appPersistConfig = {
  key: 'app',
  storage: storage,
  whitelist: ['settings', 'theme', 'language'],
};

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  app: persistReducer(appPersistConfig, appReducer),
  user: persistReducer(userPersistConfig, userReducer),
  accounts: persistReducer(accountsPersistConfig, accountsReducer),
  cards: persistReducer(cardsPersistConfig, cardsReducer),
  countries: countriesReducer,
  currencies: currenciesReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(api.middleware) 
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

const persistor = persistStore(store);
persistorManager.setPersistor(persistor);

export { store, persistor };
